export default {
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    getCustomers () {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('externalApi/getCustomers', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getTreasuryTransactions () {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('externalApi/getTreasuryTransactions', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getTerminalTransactions () {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('externalApi/getTerminalTransactions', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getTerminalSettlementInformation () {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('externalApi/getTerminalSettlementInformation', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getTreasurySettlementInformation () {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('externalApi/getTreasurySettlementInformation', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getCustomerDetails () {
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('externalApi/getCustomerDetails', this.customerId)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getCustomerDetailsTreasuryTransactions () {
      const payload = {
        page: this.payload.page,
        size: this.payload.size,
        customerId: this.customerId
      }
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('externalApi/getCustomerDetailsTreasuryTransactions', payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getCustomerDetailsTerminalTransactions () {
      const payload = {
        page: this.payload.page,
        size: this.payload.size,
        customerId: this.customerId,
        type: 'terminal'
      }
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('externalApi/getCustomerDetailsTerminalTransactions', payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getBatchDetails () {
      const payload = {
        page: this.payload.page,
        size: this.payload.size,
        ...this.routeDetails
      }
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('externalApi/setBatchDetails', payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getTreasuryBatchDetails () {
      const payload = {
        page: this.payload.page,
        size: this.payload.size,
        ...this.routeDetails
      }
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('externalApi/setTreasuryBatchDetails', payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getYieldProfileCustomers () {
      const payload = {
        page: this.payload.page,
        size: this.payload.size,
        id: this.$route.params.id
      }
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('externalApi/getYieldProfileCustomers', payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getApiCredentials () {
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('externalApi/getApiCredentials')
        .then(() => {
          this.isLoading = false
          this.webhookForm.notificationUrl = this.webhookUrl
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  async getExternalApiDashboardInformation () {
    this.isLoading = true
    const vm = this
    await this.$store
      .dispatch('externalApi/getExternalApiDashboardInformation')
      .then(() => {
        this.isLoading = false
      })
      .catch((error) => {
        const err = error.response
          ? error.response.data.error.publicMessage
          : error
        vm.$message({
          showClose: true,
          message: this.httpErrorMessage,
          type: 'error'
        })
      })
      .finally(() => {
        this.isLoading = false
      })
  },
  computed: {}
}
